// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Importa tu Layout y tus páginas
import Layout from './Layout';
import Home from './pages/Home';
import Destinos from './pages/Destinos';
import Alojamientos from './pages/Alojamientos';
import QuienesSomos from './pages/QuienesSomos';
import TerminosYCondiciones from './pages/TerminosYCondiciones';
import PoliticasPrivacidad from './pages/PoliticasPrivacidad';
import AgenciasPromotores from './pages/AgenciasPromotores';
import TrabajaConNosotros from './pages/TrabajaConNosotros';
import Paquetes from './pages/Paquetes';
import PaqueteDetalle from './pages/PaqueteDetalle';
import DestinoDetalle from './pages/DestinoDetalle';
import AlojamientoDetalle from './pages/AlojamientoDetalle';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas anidadas dentro del Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} /> 
          <Route path="destinos" element={<Destinos />} /> 
          <Route path="alojamientos" element={<Alojamientos />} />
          <Route path="quienes-somos" element={<QuienesSomos />} />
          <Route path="trabaja-con-nosotros" element={<TrabajaConNosotros />} />
          <Route path="agencias-promotores" element={<AgenciasPromotores />} />
          <Route path="terminos-y-condiciones" element={<TerminosYCondiciones />} />
          <Route path="politicas-privacidad" element={<PoliticasPrivacidad />} />
          <Route path="paquetes" element={<Paquetes />} />
          <Route path="paquetes/:slug" element={<PaqueteDetalle />} />
          <Route path="destinos/:slug" element={<DestinoDetalle />} />
          <Route path="alojamientos/:slug" element={<AlojamientoDetalle />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
